import axios from 'axios'

// axios.defaults.baseURL =
//  process.env.NODE_ENV !== 'production' ? 'http://localhost:5000' : '/';

// It's because I deploy frontend and backend to different server.(static site and web service)
// axios.defaults.baseURL =
//   process.env.NODE_ENV !== 'production' ? 'http://localhost:4000' : 'https://food-store-backend-mek5.onrender.com';

// axios.defaults.baseURL = 'https://food-store-backend-mek5.onrender.com';

// GKE
// axios.defaults.baseURL = 'http://34.86.56.229:4000';

// Google cloud run (Backend)
// axios.defaults.baseURL = 'https://online-store-backend-cloud-run-service-jeeuicbmuq-uc.a.run.app'

// axios.defaults.baseURL = 'http://localhost:4000'

// Render
axios.defaults.baseURL = 'https://online-store-service.onrender.com'

// Attach the admin API key (entered once, kept in localStorage) so the
// backend's requireAdminKey-protected write endpoints accept our requests.
// Read endpoints ignore the extra header, so sending it everywhere is fine.
axios.interceptors.request.use((config) => {
  const adminApiKey = localStorage.getItem('adminApiKey')
  if (adminApiKey) {
    config.headers['x-api-key'] = adminApiKey
  }
  return config
})

// Stale admin key recovery (e.g. after a key rotation): when a request that
// carried the stored x-api-key gets requireAdminKey's 401 back, drop the stored
// key, prompt for the new one, and retry that request once. Guarded so it never
// fires for other 401s: appKeyAuth's hard-mode 401 carries code APP_KEY_REQUIRED,
// and requests without a stored key (e.g. login) never attach x-api-key.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response, config } = error || {}
    const sentAdminKey = Boolean(config?.headers?.['x-api-key'])
    const isAdminAuthReject =
      response?.status === 401 &&
      response?.data?.error === 'Unauthorized' &&
      !response?.data?.code
    if (sentAdminKey && isAdminAuthReject && !config._adminKeyRetried) {
      localStorage.removeItem('adminApiKey')
      const newKey = (window.prompt('Admin API key rejected — enter the new x-api-key:') || '').trim()
      if (newKey) {
        localStorage.setItem('adminApiKey', newKey)
        config._adminKeyRetried = true
        config.headers['x-api-key'] = newKey
        return axios(config)
      }
    }
    return Promise.reject(error)
  }
)
